// extracted by mini-css-extract-plugin
module.exports = {"error":"ExlyRichTextEditorModal_error__1v3R0","errorText":"ExlyRichTextEditorModal_errorText__P4wzy"};